import { useEffect, useState } from "react";
import { Bot, Copy, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api, BACKEND_URL } from "../../lib/api";
import { Btn } from "./ui";
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "../ui/dialog";
import { Input } from "../ui/input";

export const BotFeedDialog = () => {
  const [open, setOpen] = useState(false);
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (open) api.get("/admin/bot-feed", { params: { origin: window.location.origin } }).then((r) => setInfo(r.data));
  }, [open]);

  const base = info ? `${BACKEND_URL}/api/feed/products?key=${info.key}` : "";
  const links = [["JSON", base], ["CSV", `${base}&format=csv`]];
  const orderLink = info ? `${BACKEND_URL}/api/feed/order?key=${info.key}&number=رقم_الطلب&phone=رقم_الجوال` : "";
  const copy = (v) => navigator.clipboard.writeText(v).then(() => toast.success("تم النسخ"));
  const rotate = async () => {
    const { data } = await api.post("/admin/bot-feed/rotate");
    setInfo({ key: data.key, last_used_at: null });
    toast.success("تم إنشاء مفتاح جديد — الرابط القديم توقف");
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><Btn variant="light" data-testid="bot-feed-button"><Bot size={16} />رابط البوت</Btn></DialogTrigger>
      <DialogContent dir="rtl" className="max-w-xl">
        <DialogTitle className="pr-8">رابط خاص للبوت</DialogTitle>
        <p className="text-sm leading-6 text-gray-600">أعطِ هذا الرابط للبوت ليقرأ الأسعار والمخزون الحالية مباشرة في أي وقت. لا تشاركه مع أحد — من يملك الرابط يستطيع قراءة المنتجات (بدون المسودات).</p>
        {info && (
          <div className="space-y-3">
            {links.map(([l, v]) => (
              <div key={l}>
                <p className="mb-1 text-xs text-gray-500">{l}</p>
                <div className="flex gap-2">
                  <Input readOnly dir="ltr" value={v} data-testid={`bot-feed-${l.toLowerCase()}-url`} className="font-mono text-xs" />
                  <Btn variant="light" onClick={() => copy(v)} data-testid={`copy-bot-feed-${l.toLowerCase()}`}><Copy size={14} /></Btn>
                </div>
              </div>
            ))}
            <div>
              <p className="mb-1 text-xs text-gray-500">استعلام عن طلب (يستبدل البوت رقم الطلب ورقم جوال العميلة — لا يظهر الطلب إلا إذا تطابق الاثنان)</p>
              <div className="flex gap-2">
                <Input readOnly dir="ltr" value={orderLink} data-testid="bot-feed-order-url" className="font-mono text-xs" />
                <Btn variant="light" onClick={() => copy(orderLink)}><Copy size={14} /></Btn>
              </div>
            </div>
            <p className="text-xs text-gray-500">آخر استخدام: {info.last_used_at ? new Date(info.last_used_at).toLocaleString("ar-SA") : "لم يُستخدم بعد"}</p>
            <Btn variant="danger" onClick={rotate} data-testid="rotate-bot-feed-key"><RefreshCw size={14} />إنشاء مفتاح جديد (يوقف الرابط القديم)</Btn>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
